var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voucher-tag"},[_c('span',{staticClass:"voucher-tag-wrap"},[_c('span',[_vm._v(_vm._s(_vm.voucherCode))]),_c('span',{staticClass:"tag-remove-icon",on:{"click":_vm.onRemoveTag}},[_c('i',{staticClass:"fas fa-times"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }